/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import Breadcrumb from "../../../../component/breadcrumb";
import ManageCustomersHierarchy from "../../manageCustomers/manageCustomersHierarchy";
import { withTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import Button from "../../../../component/button";
import { UsersIcon } from "../../../../component/icons/icons";
import classes from "../reports.module.css";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import orderClasses from "../../orders/orders.module.css";
import moment, { months } from "moment";
import Paper from "@mui/material/Paper";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import Loader from "../../../../component/loader";

// Manage order page class
class IFRSReport extends Component {
  autoRefreshIntervalId = null;
  // Declare property values that belongs to the component
  state = {
    bread: [
      { title: this.props.t("REPORTS"), url: "/ifrsReport" },
      { title: this.props.t("IFRS_REPORT"), url: "/ifrsReport" },
    ],
    loading: false,
    monthList: [
      {
        name: "Jan",
        value: 0,
      },
      {
        name: "Feb",
        value: 1,
      },
      {
        name: "Mar",
        value: 2,
      },
      {
        name: "Apr",
        value: 3,
      },
      {
        name: "May",
        value: 4,
      },
      {
        name: "June",
        value: 5,
      },
      {
        name: "July",
        value: 6,
      },
      {
        name: "Aug",
        value: 7,
      },
      {
        name: "Sep",
        value: 8,
      },
      {
        name: "Oct",
        value: 9,
      },
      {
        name: "Nov",
        value: 10,
      },
      {
        name: "Dec",
        value: 11,
      },
    ],
    yearsList: [],
    selectedYear: new Date().getFullYear(),
    selectedMonth: new Date().getMonth(),
    today: moment(new Date()).format("yyyy-MM-DD"),
    excelData: ``,
    searchedExcelData: ``,
    reportDateObject: null,
    downloadReady: false,
    reportjobId: null,
    reportJobStatus: null,
    showRefreshReport: false,
    extractedFileName: "",
    availableReportDate: "",
    autoRefreshValue: 10, // 10 seconds
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.yearsList();
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
    this.props.setCompDidMount();
    this.checkIsReportReady();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
    clearInterval(this.autoRefreshIntervalId);
    this.autoRefreshIntervalId = null;
  }
  updateIsMobile = () => {
    const isMobile = window.matchMedia("(max-width: 960px)").matches;
    this.setState({ isMobile });
  };

  toggleShowCustomerList = () => {
    this.setState((prevState) => ({
      showCustomerList: !prevState.showCustomerList,
    }));
  };
  yearsList = () => {
    var currentYear = new Date().getFullYear(),
      years = [];
    let startYear = 2020;
    while (startYear <= currentYear) {
      years.push(startYear++);
    }
    this.setState({
      yearsList: years,
    });
  };
  createDownloadFile = () => {
    clearInterval(this.autoRefreshIntervalId);
    this.autoRefreshIntervalId = null;
    this.setState({
      autoRefreshValue: 10,
      loading: true,
      downloadReady: false,
      searchedExcelData: ``,
      reportDateObject: null,
      reportjobId: null,
      reportJobStatus: null,
      showRefreshReport: false,
      extractedFileName: "",
      availableReportDate: "",
    });
    // var payload = {
    //     year: this.state.selectedYear + "",
    //     month: this.state.selectedMonth + ""
    // };
    // var index = this.state.customersList.findIndex(x => x.ban === this.state.selectedCustomer);
    // if (index > -1) {
    //     payload.customerName = this.state.customersList[index].accountName ? this.state.customersList[index].accountName : '';
    // } else {
    //     // payload.customerName = 'All Customers';
    //     payload.customerName = '';
    // }
    let action = "getMonthlyIFRSReport";

    // BusApiCall('POST', `${constants.busInternalUrl}/passthru/${action}/endpoint`, payload).then(res => {
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/reports/ifrs/monthly?month=${this.state.selectedMonth + ""}&year=${this.state.selectedYear + ""}`,
    )
      .then((res) => {
        // let excelData = res.data.jsonResponse;
        // this.setState({
        //     searchedExcelData: excelData,
        //     downloadReady: true,
        //     loading: false
        // })
        let resData = JSON.parse(res.data.jsonResponse);
        this.setState(
          {
            reportjobId: resData.jobId,
            reportJobStatus: resData.statusId,
            // loading: false,
          },
          () => {
            this.checkIsReportReady();
          },
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };
  checkIsReportReady = () => {
    this.setState(
      {
        autoRefreshValue: 10,
      },
      () => {
        clearInterval(this.autoRefreshIntervalId);
      },
    );
    this.autoRefreshIntervalId = null;
    var payload = {
      serviceName: "cumulatorGenerateIFRSReport",
      generatedBy: this.props.loggedInUserId,
    };
    if (this.state.reportjobId) {
      payload.jobId = this.state.reportjobId;
    }
    this.setState({
      loading: true,
    });
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/DOWNLOAD_IFRS_FILE/endpoint`,
      payload,
    )
      .then((res) => {
        var resData = JSON.parse(res.data.jsonResponse);
        if (resData.statusId === null) {
          if (this.autoRefreshIntervalId) {
            this.setState(
              {
                autoRefreshValue: 10,
              },
              () => {
                clearInterval(this.autoRefreshIntervalId);
              },
            );
          }
          this.setState({
            downloadReady: false,
            reportjobId: null,
            reportJobStatus: null,
            showRefreshReport: false,
            reportDateObject: null,
            searchedExcelData: ``,
            extractedFileName: "",
            loading: false,
          });
          // this.startAutoRefreshInterval();
        } else {
          if (resData.statusId === "SERVICE_FINISHED") {
            if (this.autoRefreshIntervalId) {
              this.setState(
                {
                  autoRefreshValue: 10,
                },
                () => {
                  clearInterval(this.autoRefreshIntervalId);
                },
              );
            }
            this.setState({
              searchedExcelData: resData.fileData,
              reportDateObject: resData.fileName,
              extractedFileName: resData.fileName
                ? this.formatReportFilename(resData.fileName)
                : "",
              downloadReady: true,
              showRefreshReport: false,
              loading: false,
            });
          } else {
            this.setState({
              searchedExcelData: ``,
              downloadReady: false,
              showRefreshReport: true,
              reportDateObject: resData.fileName,
              extractedFileName: resData.fileName
                ? this.formatReportFilename(resData.fileName)
                : "",
              loading: false,
            });
            this.startAutoRefreshInterval();
          }
        }
      })
      .catch((err) => {
        this.setState(
          {
            autoRefreshValue: 10,
            downloadReady: false,
            showRefreshReport: false,
            extractedFileName: "",
            loading: false,
            reportDateObject: null,
            searchedExcelData: ``,
          },
          () => {
            clearInterval(this.autoRefreshIntervalId);
          },
        );
        this.autoRefreshIntervalId = null;
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  startAutoRefreshInterval = () => {
    // Always clear old interval first
    if (this.autoRefreshIntervalId) {
      clearInterval(this.autoRefreshIntervalId);
    }

    // Reset state value
    this.setState({ autoRefreshValue: 10 });

    let time = 10; // start from 10 seconds
    this.autoRefreshIntervalId = setInterval(() => {
      time -= 1;
      this.setState({ autoRefreshValue: time });

      if (time <= 0) {
        clearInterval(this.autoRefreshIntervalId);
        this.checkIsReportReady();
      }
    }, 1000);
  };


  formatReportFilename = (filename) => {
    // Extract the datetime portion using regex
    const match = filename.match(/IFRSReport_(\d{8})_(\d{6})\.xls/);
    if (!match) return "Invalid report filename";

    const datePart = match[1]; // 20250623
    const timePart = match[2]; // 124305

    const year = datePart.substring(0, 4);
    const month = parseInt(datePart.substring(4, 6)) - 1; // JS months are 0-based
    const day = datePart.substring(6, 8);

    const hours = timePart.substring(0, 2);
    const minutes = timePart.substring(2, 4);
    const seconds = timePart.substring(4, 6);

    const date = new Date(year, month, day, hours, minutes, seconds);

    // Format it to a human-readable form
    const options = {
      year: "numeric",
      month: "long",
      // day: 'numeric',
      // hour: 'numeric',
      // minute: 'numeric',
      // second: 'numeric',
      // hour12: true
    };

    this.setState({
      availableReportDate: date.toLocaleString(undefined, options),
    });

    return `${date.toLocaleString(undefined, options)} - IFRS report`;
  };

  downloadIFRSReport = () => {
    // this.downExcelReport(this.state.searchedExcelData);
    // const fileName = this.state.monthList[this.state.selectedMonth].name + ' ' + this.state.selectedYear + `-IFRS-report.xls`;
    const fileName = this.state.extractedFileName + ".xls";
    this.base64ToXls(this.state.searchedExcelData, fileName);
  };
  base64ToXls(base64Data, fileName = "file.xls") {
    // Convert base64 to a Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/vnd.ms-excel" });

    // Create a download link
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downExcelReport = (data) => {
    console.log("check get data", data);
    const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data}`;
    const downloadLink = document.createElement("a");
    const fileName =
      this.state.monthList[this.state.selectedMonth].name +
      " " +
      this.state.selectedYear +
      `-IFRS-report.xls`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.createDownloadFile();
    }
  };
  // Render order view
  render() {
    const { t } = this.props;
    const { isMobile, showCustomerList } = this.state;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              {/* <Grid item xs={6} align={'right'}>
                                <Button
                                    onClick={
                                        () => {
                                            this.hierarchyRef.showAddAdjustment();
                                        }
                                    } >
                                        <span style={{marginRight: '.25rem', verticalAlign: 'middle'}}>
                                        <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z" fill="currentColor"/>
                                        </svg>
                                        </span>
                                    {this.props.t('NEW_SUBSCRIPTION_ADJUSTMENT')}
                                </Button>
                            </Grid> */}
            </Grid>
          </div>
        </div>
        <main>
          <Paper className="tablePaper" elevation={0}>
            <div className={classes.searchOuterDivFilter}>
              <div style={{ marginTop: "25px" }}>
                <FormControl
                  variant="outlined"
                  className="custom-select-input"
                  size={"small"}
                >
                  <InputLabel htmlFor="outlined-age-native-simple">
                    {t("Select Month")}
                  </InputLabel>
                  <Select
                    native
                    label="Select Month"
                    size={"small"}
                    variant={"outlined"}
                    name={"selectedMonth"}
                    inputProps={{
                      name: "selectedMonth",
                      id: "outlined-native-selectedMonth",
                    }}
                    //value={(a) => a.value}
                    value={this.state.selectedMonth}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                    selectClass={
                      orderClasses.inputClass +
                      " " +
                      orderClasses.statusSelectBg +
                      " " +
                      orderClasses.searchOrderSelect
                    }
                  >
                    {this.state.monthList.map((a) => (
                      <option key={a.value} value={a.value}>
                        {a.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div style={{ marginTop: "25px" }}>
                <FormControl
                  variant="outlined"
                  className="custom-select-input"
                  size={"small"}
                >
                  <InputLabel htmlFor="outlined-age-native-simple">
                    {t("Select Year")}
                  </InputLabel>
                  <Select
                    native
                    size={"small"}
                    label="Select year"
                    variant={"outlined"}
                    name={"selectedYear"}
                    inputProps={{
                      name: "selectedYear",
                      id: "outlined-native-selectedYear",
                    }}
                    //value={(a) => a.value}
                    value={this.state.selectedYear}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                    selectClass={
                      orderClasses.inputClass +
                      " " +
                      orderClasses.statusSelectBg +
                      " " +
                      orderClasses.searchOrderSelect
                    }
                  >
                    {this.state.yearsList.map((a) => (
                      <option key={a} value={a}>
                        {a}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div>
                <div className={classes.searchOrderLabelOuter}>
                  <div className={classes.searchOrderLabelInner}>
                    <Button
                      onClick={this.createDownloadFile}
                      style={{ marginTop: "15px" }}
                    >
                      {t("SEARCH")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ clear: "both" }}></div>
            <div>
              <br />
              {this.state.downloadReady ? (
                <>
                  {/* {t('YOUR_FILE_IS_READY_PLEASE_CLICK_ON_DOWNLOAD')}  */}
                  Your file is ready for {this.state.availableReportDate},
                  please click on&nbsp;
                  {/* <label onClick={() => this.downExcelReport(this.state.searchedExcelData)}
                                                style={{ color: this.props.tenantData.color ? this.props.tenantData.color : '#003161', cursor: 'pointer' }}>
                                                {t('DOWNLOAD')}
                                            </label> */}
                  <Button
                    onClick={() =>
                      this.downloadIFRSReport(this.state.searchedExcelData)
                    }
                  >
                    {t("DOWNLOAD")}
                  </Button>
                </>
              ) : (
                this.state.showRefreshReport && (
                  <>
                    {/* Your report is still being generated for {this.state.availableReportDate}. Please wait a moment and click
                                    &nbsp;<Button onClick={() => this.checkIsReportReady()}>{t('REFRESH')}</Button>&nbsp;
                                    to check again. */}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 50 50"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "4px",
                        position: "relative",
                        top: "3px",
                      }}
                    >
                      <circle
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        stroke="#4A90E2"
                        stroke-width="6"
                        stroke-linecap="round"
                        stroke-dasharray="90, 150"
                        stroke-dashoffset="0"
                      >
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 25 25"
                          to="360 25 25"
                          dur="1s"
                          repeatCount="indefinite"
                        ></animateTransform>
                      </circle>
                    </svg>
                    Report generation{" "}
                    {this.state.availableReportDate
                      ? "for " + this.state.availableReportDate
                      : ""}{" "}
                    is currently in progress.
                    <br />
                    Auto-refresh in {this.state.autoRefreshValue}s
                  </>
                )
              )}
            </div>
          </Paper>
        </main>
        <Loader loading={this.state.loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(IFRSReport));
